module.exports = __webpack_public_path__ + "static/media/fi.079f4bcb.svg";